




































import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { mdiChevronLeft } from '@mdi/js'
import { ILinkItem } from '~/assets/interfaces/navigation'

@Component({
  components: {
    ComponentIcon: () => import('~/components/icon/icon.vue'),
  },
})
export default class ComponentCategoryPath extends Vue {
  @Prop({ type: String, default: 'type-1' }) private type!: string
  @Prop({ type: Array, default: () => [] }) private tree!: ILinkItem[]
  @Prop({ type: Array, default: () => [] }) private subCategories!: ILinkItem[]

  private get amountTree() {
    return this.tree.length
  }

  private mdiChevronLeft = mdiChevronLeft
  private mounted(): void {
    this.$emit('loaded')
  }
}
